module.exports = __webpack_public_path__ + "static/media/veteranos.d9172ff6.jpg";